<forge-date-picker [formControl]="formControl" masked [min]="min" [max]="max">
    <forge-text-field [required]="isRequired" [invalid]="isInvalid" density="small">
        <input type="text" #input>

        <label *ngIf="!hideLabel" slot="label">{{label}}</label>

        <span slot="support-text">
            <ng-container *ngIf="hasError('required')">
                {{label}} is required
            </ng-container>

            <ng-container *ngIf="hasCustomValidators">
                <ng-container slot="support-text" *ngFor="let customError of customErrors">
                    <ng-container *ngIf="hasError(customError.errorKey)">
                        {{customError.message}}
                    </ng-container>
                </ng-container>
            </ng-container>
        </span>
    </forge-text-field>
</forge-date-picker>